<!-- Editor HTML -->
<ng-container *bitfUiRoleManager="componentConfig.uiRole">
  <ckeditor [editor]="editor"
    [config]="editorConfig"
    [formControl]="formControl"
    [disabled]="formItem.isDisabled"></ckeditor>
</ng-container>